import { render, staticRenderFns } from "./FeaturedQuestion.vue?vue&type=template&id=0311f15d&scoped=true"
import script from "./FeaturedQuestion.vue?vue&type=script&lang=js"
export * from "./FeaturedQuestion.vue?vue&type=script&lang=js"
import style0 from "./FeaturedQuestion.vue?vue&type=style&index=0&id=0311f15d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0311f15d",
  null
  
)

export default component.exports